import { Filters } from '@work4all/models/lib/DataProvider';
import { FilterPrimitives } from '@work4all/models/lib/DataProvider/filters';

export const queryAnd = (val: Filters) => {
  return { $and: val };
};

export const queryOr = (val: Filters) => {
  return { $or: val };
};

export const queryEquals = (val: FilterPrimitives) => {
  return { $eq: val };
};

export const queryIn = (val: FilterPrimitives[]) => {
  return { $in: val };
};

export const genNotSerializedQuery = <T extends Record<string, unknown>>(
  obj?: T
) => {
  if (!obj) {
    return;
  }

  const filter = Object.keys(obj).reduce((acc, curr) => {
    const v = obj[curr];
    if (!v) {
      return acc;
    }

    if (Array.isArray(v)) {
      acc.push({ [curr]: queryIn(v) });
      return acc;
    }

    if (typeof v === 'object') {
      acc.push({ [curr]: v });
      return acc;
    }

    acc.push({ [curr]: queryEquals(v as FilterPrimitives) });
    return acc;
  }, []);

  return filter;
};

export const genQuery = <T extends Record<string, unknown>>(obj?: T) => {
  const filter = genNotSerializedQuery(obj);

  return JSON.stringify(filter);
};
